import { z } from '@/utils/zod'

export const SystemActorTypeSchema = z.enum(['user', 'api', 'system', 'guest'])

export type SystemActorType = z.infer<typeof SystemActorTypeSchema>

export const SystemActorSchema = z
    .object({
        type: SystemActorTypeSchema,
        id: z.string().nullable(),
        name: z.string(),
    })
    .check(({ value, ...ctx }) => {
        const { type, id } = value

        let hasValidId = false

        switch (type) {
            case 'user':
                try {
                    z.objectIdString().parse(id)
                    hasValidId = true
                } catch {
                    hasValidId = false
                }
                break
            case 'api':
                try {
                    z.string().parse(id)
                    hasValidId = true
                } catch {
                    hasValidId = false
                }
                break
            case 'system':
                // May not contain any id
                hasValidId = id === null
                break
            case 'guest':
                // May not contain any id
                hasValidId = id === null
                break
        }

        if (!hasValidId) {
            ctx.issues.push({
                code: 'custom',
                input: value,
                path: ['id'],
            })
        }
    })

export type SystemActor = z.infer<typeof SystemActorSchema>
